import { useRef, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { COLORS } from "../../lib/constants";
import { DrawToolbar } from "../draw/DrawToolbar";
import { ShapesLayer, ShapeView } from "../draw/ShapesLayer";
import { useDrawing } from "../draw/useDrawing";
import { ActionButton } from "../common/Field";

const TOOLS = ["select", "arrow", "line", "cota", "text", "circle", "rect", "anomaly"];

export function PhotoOverlay({ photo }) {
  return (
    <svg viewBox={`0 0 ${photo.width} ${photo.height}`} className="absolute inset-0 w-full h-full pointer-events-none">
      <ShapesLayer shapes={photo.annotations || []} halo="#000000" />
    </svg>
  );
}

export function PhotoAnnotator({ photo, onClose, onSave }) {
  const fs = Math.max(photo.width, photo.height) / 900;
  const [shapes, setShapes] = useState(photo.annotations || []);
  const [tool, setTool] = useState("arrow");
  const [color, setColor] = useState(COLORS.dev);
  const [width, setWidth] = useState(4);
  const [label, setLabel] = useState("");
  const [selected, setSelected] = useState(null);
  const svgRef = useRef(null);
  const { draft, handlers } = useDrawing({ svgRef, tool, color, width: width * fs, label, fs, onAdd: (s) => setShapes((l) => [...l, s]) });

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-6xl bg-[#0B1520] border-[#1E2F45] max-h-[95vh] overflow-y-auto" data-testid="photo-annotator">
        <DialogHeader>
          <DialogTitle className="font-display uppercase tracking-wider text-2xl">Anotação sobre a foto</DialogTitle>
          <DialogDescription>Trace linhas e setas vermelhas, cotas e textos sobre a área afetada.</DialogDescription>
        </DialogHeader>
        <DrawToolbar tools={TOOLS} tool={tool} setTool={setTool} color={color} setColor={setColor} width={width} setWidth={setWidth} label={label} setLabel={setLabel}
          onUndo={() => setShapes((l) => l.slice(0, -1))} canDelete={!!selected} onDelete={() => { setShapes((l) => l.filter((s) => s.id !== selected)); setSelected(null); }}
          onClear={() => setShapes([])} prefix="photo" />
        <div className="border border-[#1E2F45] rounded-sm overflow-hidden bg-black flex justify-center">
          <svg ref={svgRef} viewBox={`0 0 ${photo.width} ${photo.height}`} className="max-h-[62vh] w-auto max-w-full" style={{ touchAction: "none", cursor: tool === "select" ? "default" : "crosshair" }} {...handlers} data-testid="photo-annotator-canvas">
            <image href={photo.image} x={0} y={0} width={photo.width} height={photo.height} />
            <ShapesLayer shapes={shapes} selectedId={selected} onSelect={tool === "select" ? setSelected : undefined} halo="#000000" />
            {draft && <ShapeView s={draft} halo="#000000" />}
          </svg>
        </div>
        <div className="flex justify-end gap-2">
          <ActionButton variant="outline" onClick={onClose} testId="photo-annotator-cancel">Cancelar</ActionButton>
          <ActionButton onClick={() => onSave(shapes)} testId="photo-annotator-save">Salvar anotações</ActionButton>
        </div>
      </DialogContent>
    </Dialog>
  );
}
